const routers = [

  {
    // 供求表单
    path: '/card/form',
    name: 'card_form',
    component: () => import('./Form.vue')

  }
]
export default routers